/* This file should replace dropdowm editor -> select file , so that we can use single dropdown everywhere */

import { withStyles } from "@material-ui/core";
import React from "react";
import Select from "../dataGrid/cellEditors/DropdownEditor/Select";

const styles = (theme) => ({
  dropdown: {
    "& .select__control": {
      marginTop: 0,
      border: `1px solid ${theme.AnchorBGColor}`,
      borderRadius: 4,
      "&:hover,&.select__control--is-focused": {
        borderRadius: 4,
        border: `1px solid ${theme.AnchorBGColor}`,
      },
    },
    "& .select__menu": {
      borderRadius: 4,
      border: `1px solid ${theme.AnchorBGColor}`,
      maxHeight: 260,
    },
    "& .select__menu .select__menu-list": {
      maxHeight: 260,
    },
  },
  dropdownError:{
    "& .select__control": {
      border: `1px solid ${theme.errorBorderColor}`,
      "&:hover,&.select__control--is-focused": {
        border: `1px solid ${theme.errorBorderColor}`,
      },
    }
  },
  errorMessage:{
    color: theme.errorBorderColor,
    padding:"4px 8px",
    fontSize: 12
  }
});

const Dropdown = (props) => {
  const {classes, error, dropdown, dropdownError, errorMessage, ...other} = props;
  const onChange = (value) => {
    const valueToBeChecked = value?.value ?? null;
    if(props.value !== valueToBeChecked){
        props.onChange(value)
    }
  }

  return (
    <div
      className={`${classes.dropdown} ${error ? classes.dropdownError : ""}`}
    >
      <Select
        column={{
          colDef: {
            field: "placeholder",
            cellEditorParams: {
              canAcceptNewValue: props.canAcceptNewValue || false,
              noNullValue: false,
              capitalize: false,
              format: "",
              placeholder: "",
              isClearable: props.isClearable || false,
            },
          },
        }}
        isMultiSelection={props.isMulti || false}
        data={props.options}
        {...other}
        onChange={onChange}
      />
      {error ? <div className={classes.errorMessage}>{error}</div> : null}
    </div>
  );
};
export default withStyles(styles)(Dropdown);
